import { useTranslations } from "use-intl";
import type { EnglishMessages } from "@financialharmony/i18n/messageTypes";
import { statusLabel } from "@/services/invoiceGeneration";
import { hasMessageKey } from "./hasMessageKey";

type StatusKey = keyof EnglishMessages["consultantReceivables"]["status"];

/** `statusLabel` (an issued customer invoice's lifecycle state) in the language the app shows. */
export function useInvoiceStatusLabel() {
  const t = useTranslations("consultantReceivables.status");
  return (status: string): string => (hasMessageKey<StatusKey>(t, status) ? t(status) : statusLabel(status));
}
